<template>
  <v-row no-gutters class="full-size">
    <v-row id="float-panel">
      <v-col id="folder-select-section" cols="auto" align-self="center">
        <v-row>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="previousFolder">
              <v-icon small color="white">
                mdi-less-than
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-select
                dark
                hide-details="auto"
                v-model="folderId"
                :items="folders"
                v-on:change="changeFolder"
            >
              <template v-slot:selection="data">
                <v-container class="py-0">
                  <v-row class="px-2">
                    {{ data.item.text.property.shooting_date ? data.item.text.property.shooting_date.split(' ')[0] : null }}{{ data.item.text.note ? ' (' + data.item.text.note + ')' : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'color' ||
                      data.item.text.color_type_count == 2
                    "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      可視
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'thermal' ||
                      data.item.text.color_type_count == 2
                    "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーモ
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:item="data">
                <v-container>
                  <v-row class="px-2">
                    {{ data.item.text.property.shooting_date ? data.item.text.property.shooting_date.split(' ')[0] : null }}{{ data.item.text.note ? ' (' + data.item.text.note + ')' : null }}
                  </v-row>
                  <v-row>
                    <v-chip
                        v-if="data.item.text.property.shooting_height"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.shooting_height }}m
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.gimbal_angle"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.gimbal_angle }}°
                    </v-chip>
                    <v-chip
                        v-if="data.item.text.property.drone_type"
                        x-small
                        class="ma-1"
                    >
                      {{ data.item.text.property.drone_type }}
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'color' ||
                      data.item.text.color_type_count == 2
                    "
                        color="green"
                        x-small
                        class="ma-1"
                    >
                      可視
                    </v-chip>
                    <v-chip
                        v-if="
                      data.item.text.color_type == 'thermal' ||
                      data.item.text.color_type_count == 2
                    "
                        color="orange"
                        x-small
                        class="ma-1"
                    >
                      サーモ
                    </v-chip>
                  </v-row>
                </v-container>
              </template>
            </v-select>
          </v-col>
          <v-col cols="auto" align-self="center">
            <v-btn fab color="rgba(0, 0, 0, 0.5)" small @click="nextFolder">
              <v-icon small color="white">
                mdi-greater-than
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <div id="map-compare" v-if="folders.length > 0" @click="mapCompare">
        <v-col cols="auto" align-self="center">
          <v-icon color="white">
            mdi-select-compare
          </v-icon>
        </v-col>
        <v-col align-self="center" style="padding-top: 0; padding-bottom: 0;">
          <span style="font-size: small">比較</span>
        </v-col>
      </div>
      <div id="annotation-filter" @click="openAnnotationFilterDialog">
        <v-col cols="auto" align-self="center" class="text-center">
          <v-icon color="white">
            mdi-filter-outline
          </v-icon>
        </v-col>
        <v-col align-self="center" style="padding-top: 0; padding-bottom: 0;">
          <span style="font-size: small">フィルター</span>
          <annotation-filter-dialog
              v-model="annotationFilterDialog"
              :abnormalities="annotation.db_annotation"
              @filter="filter"
              :folderId="folderId"
          ></annotation-filter-dialog>
        </v-col>
      </div>
    </v-row>
    <v-col>
      <div id="map2d" ref="map2d"></div>
      <annotation-add-dialog
          v-model="showAnnotationAddDialog"
          :info="annotationAddInfo"
          @closed="changeAnnotationMode('none')"
          @added="afterAddAnnotation"
      ></annotation-add-dialog>
      <annotation-edit-dialog
          v-model="showAnnotationEditDialog"
          :info="annotationEditInfo"
          @edited="afterEditAnnotation"
          @deleted="afterDeleteAnnotation"
          @displayAnnotationImages="displayAnnotationImages"
      ></annotation-edit-dialog>
      <annotation-copy-dialog
          v-model="showAnnotationCopyDialog"
          @copied="afterCopyAnnotation"
      ></annotation-copy-dialog>
      <show-image-dialog
        v-model="showImageDialog"
        :info="imageInfo"
        :annotation="clickedAnnotation"
        @updateRotate="updateRotate"
        @addCropImage="updateCropImage"
        @updateCropImage="updateCropImage"
        @addCropAbnormality="updateCropAbnormality"
        @updateCropAbnormality="updateCropAbnormality"
        @deleteCropImage="deleteCropImage"
        @deleteCropAbnormality="deleteCropAbnormality"
        @showAirprobeAnnotation="showAirprobeAnnotation"
        v-if="showImageDialog"
      ></show-image-dialog>

      <v-snackbar v-model="showSnackbar" top center>
        <span v-html="snackbarMessage"></span>
        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" @click="showSnackbar = false"
          >閉じる
          </v-btn
          >
        </template>
      </v-snackbar>
    </v-col>
    <v-col cols="auto" id="navi-col" class="unhide-btn-right">
      <div id="navi">
        <v-expansion-panels accordion tile multiple v-model="panel">
          <v-expansion-panel
              v-for="(item, i) in layers"
              :key="i"
              :disabled="item.mapUrl === '' || (item.value === 'theta_image360' && !item.list.length) || item.disable"
          >
            <v-expansion-panel-header v-show="checkLayer(item)" class="px-3">
              <v-checkbox
                  v-model="item.visible"
                  :label="item.text"
                  @click="onChangeVisible($event, item)"
                  hide-details="auto"
              ></v-checkbox>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-slider
                  v-model="item.transparency"
                  :max="100"
                  label="透明性"
                  class="align-center"
                  hide-details="auto"
                  @input="onChangeTransparency(item)"
                  v-if="!['basic', 'coordinate_color', 'coordinate_thermal', 'theta_image360'].includes(item.value)"
              >
              </v-slider>
              <div class="mt-3" v-if="item.value === 'annotation'">
                <v-row>
                  <v-col class="pl-2 pr-1" v-if="editable">
                    <v-btn
                        class="px-1"
                        block
                        :color="annotation.mode === 'add' ? 'primary' : 'default'"
                        @click="changeAnnotationMode(annotation.mode === 'add' ? 'none' : 'add')"
                        :disabled="!layers.find(x => x.value === 'annotation').visible || annotation.allSelect"
                    >
                      <v-icon left>mdi-map-marker-plus</v-icon>
                      追加
                    </v-btn>
                  </v-col>
                  <v-col class="px-1" v-if="editable">
                    <v-btn
                        class="px-1"
                        :color="annotation.annotationMoveMode ? 'primary' : 'default'"
                        block
                        @click="annotation.setAnnotationMoveMode()"
                        :disabled="!layers.find(x => x.value === 'annotation').visible || annotation.allSelect">
                      <v-icon left>mdi-cursor-move</v-icon>
                      移動
                    </v-btn>
                  </v-col>
                  <v-col class="pr-2 pl-1">
                    <v-btn
                        class="px-1"
                        block
                        color='default'
                        @click="onCopyAnnotation()"
                        :disabled="!layers.find(x => x.value === 'annotation').visible || !annotation.canCopy || annotation.allSelect"
                    >
                      <v-icon left>mdi-content-copy</v-icon>
                      コピー
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pl-2 pr-1" v-if="editable">
                    <v-btn
                        block
                        :color="annotation.allSelect ? 'primary' : 'default'"
                        @click="selectAllAnnotation()"
                        :disabled="!layers.find(x => x.value === 'annotation').visible || !annotation.canCopy"
                    >
                      <v-icon left>mdi-select-multiple</v-icon>
                      一括選択
                    </v-btn>
                  </v-col>
                  <v-col class="pr-2 pl-1" v-if="editable">
                    <v-btn
                        block
                        v-if="layers.find(x => x.value === 'annotation').visible && annotation.allSelect"
                        color='error'
                        @click="deleteAllAnnotation()"
                    >
                      <v-icon left>mdi-delete-empty</v-icon>
                      一括削除
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <span class="text-caption grey--text text--darken-1 px-4">個別のアノテーションのコピーペースト方法:
                    <br>① 個別のアノテーションをクリック。
                    <br>② キーボード「C」を押す。（コピー）
                    <br>③ キーボード「V」を押す。（ペースト）
                  </span>
                </v-row>
              </div>
              <div v-if="item.value === 'basic'" class="ml-5">
                <v-checkbox
                    v-model="item.satellite.visible"
                    :label="item.satellite.text"
                    @click="onChangeVisible($event, item.satellite)"
                    hide-details="auto"
                ></v-checkbox>
                <v-checkbox
                    v-model="item.openStreetMap.visible"
                    :label="item.openStreetMap.text"
                    @click="onChangeVisible($event, item.openStreetMap)"
                    hide-details="auto"
                ></v-checkbox>
              </div>
              <div class="mt-3" v-if="['coordinate_color', 'coordinate_thermal'].includes(item.value)">
                <v-checkbox
                    v-model="item.cal_coordinate.visible"
                    label="補正あり"
                    @click="onChangeVisible($event, item.cal_coordinate)"
                ></v-checkbox>
                <v-checkbox
                    v-model="item.origin_coordinate.visible"
                    label="補正なし"
                    @click="onChangeVisible($event, item.origin_coordinate)"
                ></v-checkbox>
              </div>
              <v-list v-if="item.value === 'theta_image360'">
                <v-list-item v-for="(value, key) in item.list" :key="key">
                  <v-checkbox
                      v-model="value.visible"
                      :label="value.text"
                      @click="image360.setVisible(value.visible ,value.value)"
                      hide-details="auto"
                  ></v-checkbox>
                </v-list-item>
              </v-list>
              <div v-if="item.value === 'airprobe_annotation' && editable">
                <v-row v-if="folderApp !== 'airprobe' && userRole === 'admin'">
                  <v-col class="pl-2 pr-1">
                    <v-btn
                        block
                        @click="sendAirprobe"
                    >
                      <v-icon left>mdi-robot-outline</v-icon>
                      AI A（有料）異常検知
                    </v-btn>
                    <airprobe-required-data-dialog v-model="requiredDataDialog" :folderId="folderId" @sendAirprobeRequest="sendAirprobeRequest"></airprobe-required-data-dialog>
                  </v-col>
                </v-row>
                <div v-if="airprobeAnnotation.sourceLength !== 0 && !importedFolder">
                  <v-row>
                    <v-col class="pl-2 pr-1">
                      <v-btn
                          block
                          @click="openTransferDialog"
                      >
                        <v-icon left>mdi-transfer</v-icon>
                        変換
                      </v-btn>
                      <airprobe-annotation-transfer-dialog
                          v-model="airprobeAnnotationTransferDialog"
                          :airprobeAbnormalities="airprobeAnnotation.source"
                          :folderId="folderId"
                          @transfered="transferedAirprobeAnnotation"
                          @reset="resetAirprobeAnnotation"
                      ></airprobe-annotation-transfer-dialog>
                    </v-col>
                  </v-row>
                  <div class="text-caption">『アノテーション』にコピーするアクション：</div>
                  <v-row>
                    <v-col>
                      <v-btn @click="overwriteAnnotation" block>
                        置き換える
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn @click="mergeAnnotation" block>
                        追加でコピー
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </div>
<!--              <div v-if="item.value === 'thermal'">-->
<!--                <v-row>-->
<!--                  <v-col cols="auto" style="width: 80%;">-->
<!--                    <span>グレースケース</span>-->
<!--                  </v-col>-->
<!--                  <v-col cols>-->
<!--                    <v-checkbox hide-details v-model="greyScale"></v-checkbox>-->
<!--                  </v-col>-->
<!--                </v-row>-->
<!--              </div>-->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-btn x-small class="btn-origin-left" height="67px" @click="hideBtnLeft">
          <v-icon small v-if="hideLeft == compared">mdi-less-than</v-icon>
          <v-icon small v-if="hideLeft != compared">mdi-greater-than</v-icon>
        </v-btn>
      </div>
    </v-col>
    <map-compare-dialog
        v-model="compared"
        :folderId="folderId"
        :folders="folders"
        :layers="layers"
        :mapInitialPosition="mapInitialPosition"
        :annotationSource="annotation.annotationLayer.getSource()"
        @changeFolder="changeFolderId"
        :airprobeAnnotation="airprobeAnnotation"
        :getLayerById="getLayerById"
        :getNaviLayerByValue="getNaviLayerByValue"
        v-if="compared">
    </map-compare-dialog>
    <image360-dialog v-model="image360.openImage360" :image360="image360.image360" :map="map" v-if="image360.openImage360"></image360-dialog>
    <!-- Invisible File Input -->
    <input
        multiple
        ref="csvUploader"
        class="d-none"
        type="file"
        accept="text/csv, .csv"
        @change="uploadCSV"
    />
  </v-row>
</template>

<script>
import {store} from "@/store";
import Annotation from "@/utils/annotation";
import Coordinate from "@/utils/coordinate";
import AnnotationAddDialog from "@/components/dialog/AnnotationAddDialog";
import AnnotationEditDialog from "@/components/dialog/AnnotationEditDialog";
import AnnotationCopyDialog from "@/components/dialog/AnnotationCopyDialog";
import ShowImageDialog from "@/components/dialog/ShowImageDialog";
import View from "ol/View";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import "ol/ol.css";
import OSM from "ol/source/OSM";
import XYZ from "ol/source/XYZ";
import router from "@/router";
import LayerGroup from "ol/layer/Group";
import TileState from "ol/TileState";
import * as olProj from 'ol/proj';
import {add} from 'ol/coordinate';
import MapCompareDialog from "@/components/dialog/MapCompareDialog";
import Image360 from "@/utils/image360";
import Image360Dialog from "@/components/dialog/Image360Dialog";
import AirprobeAnnotation from "@/utils/airprobeAnnotation";
import AirprobeRequiredDataDialog from "@/components/dialog/AirprobeRequiredDataDialog";
import AirprobeAnnotationTransferDialog from "@/components/dialog/AirprobeAnnotationTransferDialog";
import AnnotationFilterDialog from "@/components/dialog/AnnotationFilterDialog";

export default {
  name: "View2D",
  components: {
    "annotation-add-dialog": AnnotationAddDialog,
    "annotation-edit-dialog": AnnotationEditDialog,
    "annotation-copy-dialog": AnnotationCopyDialog,
    "show-image-dialog": ShowImageDialog,
    "map-compare-dialog": MapCompareDialog,
    "image360-dialog": Image360Dialog,
    'airprobe-required-data-dialog': AirprobeRequiredDataDialog,
    'airprobe-annotation-transfer-dialog': AirprobeAnnotationTransferDialog,
    'annotation-filter-dialog': AnnotationFilterDialog,
  },
  data() {
    return {
      userRole: store.state.role,
      greyScale: true,
      folderId: this.$route.params.folderId,
      compared: false,
      mapviewState: store.state.mapview,
      panel: [0],
      layers: null,
      map: null,
      mapInitialPosition: {
        bound_1_lng: 0,
        bound_1_lat: 0,
        bound_2_lng: 0,
        bound_2_lat: 0,
      },
      folders: [],
      showAnnotationAddDialog: false,
      showAnnotationEditDialog: false,
      showAnnotationCopyDialog: false,
      showSnackbar: false,
      snackbarMessage: null,
      annotation: new Annotation(),
      annotationAddInfo: {},
      annotationEditInfo: {},
      hideLeft: true,

      showImageDialog: false,
      imageInfo:{},
      orign_photos_color: [],
      cal_photos_color: [],
      orign_photos_thermal: [],
      cal_photos_thermal: [],
      originLonLatColorLayer: new Coordinate('origin_color'),
      calcLonLatColorLayer: new Coordinate('cal_color'),
      originLonLatThermalLayer: new Coordinate('origin_thermal'),
      calcLonLatThermalLayer: new Coordinate('cal_thermal'),

      image360: new Image360(this.axios, this.$route.params.folderId, this.setImage360Visible),
      currentPosition: null,
      selectedAnnotation: null,
      copiedAnnotation: null,
      errorReasons: {
        "crack": "割れ",
        "sediment": "堆積物",
        "vegetation": "植生",
      },
      errorTypes: {
        "cell": "ホットスポット",
        "multicell": "マルチホットスポット",
        "cluster": "クラスタバイパス",
        "module": "モジュール異常",
        "string": "ストリング異常",
        "shadow": "影",
        'junction': 'ジャンクションボックス過熱',
        'pid': 'ＰＩＤ現象の疑い',
        "new": "新規"
      },
      airprobeAnnotation: new AirprobeAnnotation(),
      clickedAnnotation: null,
      requiredDataDialog: false,
      requiredData: {
        dc: 0,
      },
      airprobeAnnotationTransferDialog: false,
      annotationFilterDialog: false,
      folder: null,
      folderApp: 'airprobe',
      importedFolder: false,

      annotationFilter: {
        panel_error_types: null,
        panel_error_reasons: null,
      },
      reportStatus: 'NEW'
    };
  },

  methods: {
    initMap() {
      this.resetLayers();
      this.axios
          .get("/api/folder/layers-info/" + this.folderId)
          .then((response) => {
            this.reportStatus = response.data.report_status;
            store.updateCurrentReportStatus(this.reportStatus);
            this.importedFolder = response.data.csv_import_folder;
            this.annotationFilter.panel_error_types = store.getFilter(this.folderId).panel_error_types;
            this.annotationFilter.panel_error_reasons = store.getFilter(this.folderId).panel_error_reasons;
            // const airprobeLayer = this.getNaviLayerByValue('airprobe_annotation', this.layers);
            // airprobeLayer.disable = response.data.annotation.airprobe_abnormality.list.length === 0;
            // if (!airprobeLayer.disable){
            //   this.panel = [0, 1];
            // }
            // else {
            //   this.panel = [0];
            // }

            this.folder = response.data.folder;
            this.folderApp = this.folder.app;
            this.setDDMapPlanToMap(this.layers,response.data);
            this.setCoordinate(response.data);
            this.map = new Map({
              target: this.$refs.map2d,
              layers: [
                this.annotation.annotationLayer,
                new TileLayer({
                  id: 'diagram',
                  zIndex: 4,
                  opacity: this.getNaviLayerByValue('diagram', this.layers).transparency,
                  title: "図面",
                  visible: this.getNaviLayerByValue('diagram', this.layers).visible,
                  extent: [
                    this.getNaviLayerByValue('diagram', this.layers).bound1Lng,
                    this.getNaviLayerByValue('diagram', this.layers).bound1Lat,
                    this.getNaviLayerByValue('diagram', this.layers).bound2Lng,
                    this.getNaviLayerByValue('diagram', this.layers).bound2Lat,
                  ],
                  source: null,
                }),
                new TileLayer({
                  id: 'thermal',
                  zIndex: 3,
                  opacity: this.getNaviLayerByValue('thermal', this.layers).transparency,
                  title: "サーモオルソ画像",
                  visible: this.getNaviLayerByValue('thermal', this.layers).visible,
                  extent: [
                    this.getNaviLayerByValue('thermal', this.layers).bound1Lng,
                    this.getNaviLayerByValue('thermal', this.layers).bound1Lat,
                    this.getNaviLayerByValue('thermal', this.layers).bound2Lng,
                    this.getNaviLayerByValue('thermal', this.layers).bound2Lat,
                  ],
                  source: new XYZ({
                    maxZoom: this.getNaviLayerByValue('thermal', this.layers).maxZoom,
                    minZoom: 17,
                    attributions: "",
                    url: this.getNaviLayerByValue('thermal', this.layers).mapUrl,
                    tileSize: [256, 256],
                  }),
                }),
                new TileLayer({
                  id: 'color',
                  zIndex: 2,
                  opacity: this.getNaviLayerByValue('color', this.layers).transparency,
                  visible: this.getNaviLayerByValue('color', this.layers).visible,
                  title: "可視オルソ画像",
                  extent: [
                    this.getNaviLayerByValue('color', this.layers).bound1Lng,
                    this.getNaviLayerByValue('color', this.layers).bound1Lat,
                    this.getNaviLayerByValue('color', this.layers).bound2Lng,
                    this.getNaviLayerByValue('color', this.layers).bound2Lat,
                  ],
                  source: new XYZ({
                    maxZoom: this.getNaviLayerByValue('color', this.layers).maxZoom,
                    minZoom: 17,
                    attributions: "",
                    url: this.getNaviLayerByValue('color', this.layers).mapUrl,
                    tileSize: [256, 256],
                  }),
                }),
                new LayerGroup({
                  id: 'basic',
                  layers: [
                    new TileLayer({
                      id: 'Satellite',
                      zIndex: 1,
                      title: "Satellite",
                      opacity: this.getNaviLayerByValue('basic', this.layers).satellite.transparency,
                      visible: this.getNaviLayerByValue('basic', this.layers).satellite.visible,
                      source: new OSM({
                        minZoom: 17,
                        maxZoom: 17,
                        url: '/api/tiles/{z}/{x}/{y}',
                        tileLoadFunction: (tile, src) => {
                          const xhr = new XMLHttpRequest();
                          xhr.responseType = 'blob';
                          xhr.addEventListener('loadend', function () {
                            const data = this.response;
                            if (data !== undefined) {
                              tile.getImage().src = URL.createObjectURL(data);
                            } else {
                              tile.setState(TileState.ERROR);
                            }
                          });
                          xhr.addEventListener('error', function () {
                            tile.setState(TileState.ERROR);
                          });
                          xhr.open('GET', src);
                          xhr.setRequestHeader('Authorization', `Bearer ${store.state.token}`);
                          xhr.send();
                        }
                      }),
                    }),
                    new TileLayer({
                      id: 'OpenStreetMap',
                      zIndex: 0,
                      title: "OpenStreetMap",
                      opacity: this.getNaviLayerByValue('basic', this.layers).openStreetMap.transparency,
                      visible: this.getNaviLayerByValue('basic', this.layers).openStreetMap.visible,
                      source: new OSM(),
                    }),
                  ]
                }),
                new LayerGroup({
                  id: 'coordinate_color',
                  zIndex: 5,
                  opacity: 100,
                  title: "可視素材画像",
                  visible: false,
                  layers: [
                    this.originLonLatColorLayer.layer,
                    this.calcLonLatColorLayer.layer,
                  ]
                }),
                new LayerGroup({
                  id: 'coordinate_thermal',
                  zIndex: 6,
                  opacity: 100,
                  title: "サーモ素材画像",
                  visible: false,
                  layers: [
                    this.originLonLatThermalLayer.layer,
                    this.calcLonLatThermalLayer.layer,
                  ]
                }),
                this.image360.image360MapLayer,
                this.airprobeAnnotation.airprobeAnnotationLayer,

              ],

              view: new View({
                maxZoom: 23,
                zoom: 17,
                center: [
                  (this.mapInitialPosition.bound_1_lng +
                      this.mapInitialPosition.bound_2_lng) /
                  2,
                  (this.mapInitialPosition.bound_1_lat +
                      this.mapInitialPosition.bound_2_lat) /
                  2,
                ],
              }),
            });
            const mapExtent = [
              this.mapInitialPosition.bound_1_lng - 1000,
              this.mapInitialPosition.bound_1_lat - 1000,
              this.mapInitialPosition.bound_2_lng + 1000,
              this.mapInitialPosition.bound_2_lat + 1000,
            ];

            const screenExtent = this.map.getView().calculateExtent();
            mapExtent.forEach((position, index) => {
              if (position < screenExtent[index] && index >= 2) {
                mapExtent[index] = screenExtent[index];
              }
              if (position > screenExtent[index] && index <= 1) {
                mapExtent[index] = screenExtent[index];
              }
            });

            this.map.setView(new View({
              maxZoom: 23,
              zoom: 17,
              center: [
                (this.mapInitialPosition.bound_1_lng +
                    this.mapInitialPosition.bound_2_lng) /
                2,
                (this.mapInitialPosition.bound_1_lat +
                    this.mapInitialPosition.bound_2_lat) /
                2,
              ],
              extent: mapExtent,
            }));

            this.map.getView().setZoom(18);
            this.map
                .getView()
                .fit([
                  this.mapInitialPosition.bound_1_lng,
                  this.mapInitialPosition.bound_1_lat,
                  this.mapInitialPosition.bound_2_lng,
                  this.mapInitialPosition.bound_2_lat,
                ]);

            this.map.on("pointermove", (evt) => {
              if (!this.getNaviLayerByValue('annotation', this.layers).visible || this.compared) return;
              if (evt.dragging) {
                if (this.annotation.allSelect){
                  const pixel = this.map.getEventPixel(evt.originalEvent);
                  const hit = this.map.hasFeatureAtPixel(pixel);
                  if (hit) {
                    Promise.resolve(this.annotation.annotationLayer.getFeatures(pixel)).then((value) => {
                      for (let feature of this.annotation.select){
                        if (feature.id_ == value[0].id_){
                          this.annotation.selected = feature;
                          this.annotation.coordinatesDelta[0] = value[0].getGeometry().getCoordinates()[0] - feature.coordinates[0];
                          this.annotation.coordinatesDelta[1] = value[0].getGeometry().getCoordinates()[1] - feature.coordinates[1];
                          feature.coordinates = value[0].getGeometry().getCoordinates();
                          break;
                        }
                      }
                      this.annotation.annotationLayer.getSource().forEachFeature((feature) => {
                        if (feature.id_ != this.annotation.selected.id_){
                          feature.getGeometry().setCoordinates(add(feature.getGeometry().getCoordinates(), this.annotation.coordinatesDelta));
                        }
                      });
                    });
                  }
                }
                return;
              }
              const pixel = this.map.getEventPixel(evt.originalEvent);
              const hit = this.map.hasFeatureAtPixel(pixel);
              this.map.getTarget().style.cursor = hit ? 'pointer' : '';
              this.currentPosition = evt.coordinate;
            });

            this.map.on("click", (evt) => {
              if (!this.getNaviLayerByValue('annotation', this.layers).visible || this.compared || this.annotation.allSelect) return;

            // アノテーション追加の場合
            if (this.annotation.mode === "add") {
              if (this.annotationAddInfo['type']) {
                this.annotationAddInfo['coordinates'] = evt.coordinate;
              } else {
                this.annotationAddInfo = {
                  type: "cell",
                  reason: null,
                  coordinates: evt.coordinate,
                };
              }
              this.showAnnotationAddDialog = true;
              this.annotation.addTempFeature(this.annotationAddInfo);
            } else {
              this.annotation.annotationLayer
                .getFeatures(evt.pixel)
                .then((features) => {
                  const feature = features.length ? features[0] : undefined;
                  if (feature) {
                    let thermalImages = [];
                    let colorImages = [];
                    if(this.folder.app !== 'airprobe'){
                      thermalImages = this.getImages(this.originLonLatThermalLayer.layer, feature);
                      colorImages = this.getImages(this.originLonLatColorLayer.layer, feature);
                    }
                    else{
                      thermalImages = this.getAPImages(this.calcLonLatThermalLayer.layer, feature, 'thermal');
                      colorImages = this.getAPImages(this.calcLonLatColorLayer.layer, feature, 'color');
                    }

                    this.annotationEditInfo = {
                      id: feature.getId(),
                      type: feature.get("type"),
                      reason: feature.get("reason"),
                      coordinates: feature.getGeometry().getCoordinates(),
                      thermalImages: thermalImages,
                      colorImages: colorImages,
                    };
                    this.clickedAnnotation = feature;
                    this.showAnnotationEditDialog = true;
                    this.annotation.mode = "edit";
                    this.selectedAnnotation = feature;
                  }
                  else {
                    this.selectedAnnotation = null;
                  }
                });
            }
          });

            this.map.on("click", (evt) => {
              if(this.getNaviLayerByValue('coordinate_color', this.layers).visible && this.getNaviLayerByValue('coordinate_color', this.layers).origin_coordinate.visible){
                this.displayImage(this.originLonLatColorLayer.layer, evt, this.orign_photos_color, 'color');
              }
              if(this.getNaviLayerByValue('coordinate_color', this.layers).visible && this.getNaviLayerByValue('coordinate_color', this.layers).cal_coordinate.visible){
                this.displayImage(this.calcLonLatColorLayer.layer, evt, this.cal_photos_color, 'color');
              }
              if(this.getNaviLayerByValue('coordinate_thermal', this.layers).visible && this.getNaviLayerByValue('coordinate_thermal', this.layers).cal_coordinate.visible){
                this.displayImage(this.calcLonLatThermalLayer.layer, evt, this.cal_photos_thermal, 'thermal');
              }
              if(this.getNaviLayerByValue('coordinate_thermal', this.layers).visible && this.getNaviLayerByValue('coordinate_thermal', this.layers).origin_coordinate.visible){
                this.displayImage(this.originLonLatThermalLayer.layer, evt, this.orign_photos_thermal, 'thermal');
              }
            });

            this.image360.setClickEvent(this.map);

            // this.translateLayer('color');
            // this.translateLayer('thermal');

            this.annotation.init(this.map, response.data.annotation, (info) => this.afterMoveAnnotation(info));
            this.annotation.filter(store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
            this.airprobeAnnotation.init(this.map, response.data.annotation);
            const filter = JSON.parse(JSON.stringify(store.getFilter(this.folderId)))
            if (store.getFilterFirstLoad(this.folderId)){
              response.data.annotation.airprobe_abnormality.list.forEach((abnormality) => {
                if (filter.airprobe_error_types.findIndex(errorType => errorType === abnormality.airprobe_type) < 0) {
                  if (abnormality.airprobe_type){
                    filter.airprobe_error_types.push(abnormality.airprobe_type);
                  }
                }
                if (filter.airprobe_severities.findIndex(severity => severity === abnormality.airprobe_severity) < 0){
                  if (abnormality.airprobe_severity){
                    filter.airprobe_severities.push(abnormality.airprobe_severity);
                  }
                }
              })
              store.updateFilter(filter, this.folderId);
            }
            this.airprobeAnnotation.filter(store.getFilter(this.folderId).airprobe_error_types, store.getFilter(this.folderId).airprobe_severities, store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
          })
          .catch(() => {
            store.showErrorDialog("該当データがありません。");
          });
    },

    calculateDistance(a, b){
      return Math.sqrt(Math.pow(a[0]-b[0], 2) + Math.pow(a[1]-b[1], 2));
    },
    displayAnnotationImages(coord, listImage, position, imageType){
      const imageName = listImage[position].src.split('/');
      this.imageInfo = {
        long: coord[0],
        lat: coord[1],
        src: listImage[position].src,
        name: imageName[imageName.length - 1],
        list: listImage,
        currentIndex: position,
        type: imageType,
        rotate: listImage[position].rotate,
        crop: listImage[position].crop,
        annotation_mark: listImage[position].annotation_mark,
        app: listImage[position].type,
        filtered: listImage[position].filtered
      }
      this.showImageDialog = true;
    },
    getImages(layer, feature){
      const array = layer.getSource().getFeatures();
      array.sort((a, b) => {
        return this.calculateDistance(feature.getGeometry().getCoordinates(), a.getGeometry().getCoordinates()) - this.calculateDistance(feature.getGeometry().getCoordinates(), b.getGeometry().getCoordinates());
      });
      const images = array.slice(0,4).map((image) => {
        let filtered = image.get('filtered');
        if (image.get('filtered') === undefined || image.get('filtered') === null){
          filtered = false;
        }
        return {src: image.get('name'), rotate: image.get('rotate'), crop: image.get('crop'),
                annotation_mark: image.get('annotation_mark'), type: 'drone',
                filtered: filtered,
                distance: this.calculateDistance(feature.getGeometry().getCoordinates(), image.getGeometry().getCoordinates())};
      });
      return images;
    },
    getAPImages(layer, feature, color_type){
      if (feature.get(`airprobe_${color_type}_image`)){
        const array = layer.getSource().getFeatures();
        if (array.length > 0){
          array.sort((a, b) => {
            return a.get('name').localeCompare(b.get('name'))
          });
          let feature_name = feature.get(`airprobe_${color_type}_image`);
          for (let i = 0; i < array.length; i++) {
            const array_name = array[i].get('name').split(/[\\/]/).pop().split('.')[0];
            if(feature_name.includes(array_name)){
              let min = i - 2;
              let max = i + 2;
              if (min < 0){
                min = 0;
                max = 4;
              }
              if (max > array.length){
                max = array.length;
                min = max - 4;
              }
              return array.slice(min, max).map((image) => {
                let filtered = image.get('filtered');
                if (image.get('filtered') === undefined || image.get('filtered') === null){
                  filtered = false;
                }
                return {src: image.get('name'), rotate: image.get('rotate'), crop: image.get('crop'),
                  annotation_mark: image.get('annotation_mark'), type: 'airprobe',
                  filtered: filtered,
                  distance: this.calculateDistance(feature.getGeometry().getCoordinates(), image.getGeometry().getCoordinates())};
              });
            }
          }
        }
      }
      return this.getImages(layer, feature);
    },
    handleKeyPressed(evt){
      if (!store.state.openDialog){
        if (evt.code === "KeyC" && this.selectedAnnotation){
          this.copiedAnnotation = this.selectedAnnotation;
          if (this.copiedAnnotation.get('reason')){
            this.showSnackbarMessage(`｢${this.errorReasons[this.copiedAnnotation.get('reason')]}の為の${this.errorTypes[this.copiedAnnotation.get('type')]}」アノテーションをコピーしました。<br/>ペーストのため、キーボード『V』を押してください。`);
          }
          else {
            this.showSnackbarMessage(`｢${this.errorTypes[this.copiedAnnotation.get('type')]}」アノテーションをコピーしました。<br/>ペーストのため、キーボード『V』を押してください。`);
          }
        }
        else if (evt.code === "KeyV" && this.copiedAnnotation){
          const annotationCopyInfo = {
            type: this.copiedAnnotation.get('type'),
            reason: this.copiedAnnotation.get('reason'),
            coordinates: this.currentPosition,
          };
          this.axios
              .post("/api/annotation/" + this.mapviewState.folderId, annotationCopyInfo)
              .then((response) => {
                this.annotation.addFeature(response.data);
                this.showSnackbarMessage("アノテーション追加は完了しました。");
              })
              .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
              });
        }
      }
    },
    onChangeVisible(event, layer) {
      switch (layer.value){
        case 'Satellite':
        case 'OpenStreetMap': {
          let mapLayer = this.getLayerById(layer.value, this.map);
          if (mapLayer){
            mapLayer.setVisible(layer.visible);
          }
          const naviLayer = this.getNaviLayerByValue('basic', this.layers);
          naviLayer.visible = naviLayer.openStreetMap.visible || naviLayer.satellite.visible;
          mapLayer = this.getLayerById('basic', this.map);
          if (mapLayer){
            mapLayer.setVisible(naviLayer.visible);
          }
          break;
        }
        case 'basic': {
          layer.openStreetMap.visible = layer.visible;
          layer.satellite.visible = layer.visible;
          this.getLayerById(layer.value, this.map).setVisible(layer.visible);
          this.getLayerById(layer.openStreetMap.value, this.map).setVisible(layer.visible);
          this.getLayerById(layer.satellite.value, this.map).setVisible(layer.visible);
          break;
        }
        case 'origin_color':
        case 'cal_color': {
          this.getLayerById(layer.value, this.map).setVisible(layer.visible);
          const naviLayer = this.getNaviLayerByValue('coordinate_color', this.layers);
          naviLayer.visible = naviLayer.cal_coordinate.visible || naviLayer.origin_coordinate.visible;
          const mapLayer = this.getLayerById('coordinate_color', this.map);
          if (mapLayer){
            mapLayer.setVisible(naviLayer.visible);
          }
          break;
        }

        case 'origin_thermal':
        case 'cal_thermal': {
          this.getLayerById(layer.value, this.map).setVisible(layer.visible);
          const naviLayer = this.getNaviLayerByValue('coordinate_thermal', this.layers);
          naviLayer.visible = naviLayer.cal_coordinate.visible || naviLayer.origin_coordinate.visible;
          const mapLayer = this.getLayerById('coordinate_thermal', this.map);
          if (mapLayer){
            mapLayer.setVisible(naviLayer.visible);
          }
          break;
        }
        case 'coordinate_thermal':
        case 'coordinate_color': {
          this.getLayerById(layer.value, this.map).setVisible(layer.visible);
          if (layer.visible){
            layer.cal_coordinate.visible = false;
            layer.origin_coordinate.visible = layer.visible;
            this.getLayerById(layer.origin_coordinate.value, this.map).setVisible(layer.visible);
            this.getLayerById(layer.cal_coordinate.value, this.map).setVisible(false);
          }
          else {
            layer.cal_coordinate.visible = false;
            layer.origin_coordinate.visible = false;
            this.getLayerById(layer.origin_coordinate.value, this.map).setVisible(false);
            this.getLayerById(layer.cal_coordinate.value, this.map).setVisible(false);
          }
          break;
        }
        case 'annotation':{
          this.getLayerById(layer.value, this.map).setVisible(layer.visible);
          this.changeAnnotationMode('none');
          break;
        }
        case 'theta_image360': {
          this.image360.setVisible(layer.visible);
          break;
        }
        default: {
          this.getLayerById(layer.value, this.map).setVisible(layer.visible);
        }
      }

      event.cancelBubble = true;
    },
    onChangeTransparency(layer) {
      this.getLayerById(layer.value, this.map).setOpacity(layer.transparency / 100);
    },
    changeColorTypeVisible(colorType, value) {
      const layer = this.layers.find(x => x.value == colorType);
      layer.visible = value;
      this.getLayerById(layer.value, this.map).setVisible(layer.visible);
    },
    setMapLayerLocation(layer, ddMapPlan) {
      layer.mapUrl = ddMapPlan.path;
      layer.bound1Lng = ddMapPlan.bound_1_lng;
      layer.bound1Lat = ddMapPlan.bound_1_lat;
      layer.bound2Lng = ddMapPlan.bound_2_lng;
      layer.bound2Lat = ddMapPlan.bound_2_lat;
      layer.lat_translate = ddMapPlan.lat_translate;
      layer.lng_translate = ddMapPlan.lng_translate;
      layer.maxZoom = ddMapPlan.max_zoom;
      layer.visible = true; 
    },
    displayOrigin(layer){

      layer.mapUrl = true;
      // layer.visible = true;
    },
    setDDMapPlanToMap(layer, ddMapPlan) {
      const validColorTypes = [];
      let colorType;
      if (ddMapPlan["color"]) {
        this.setMapLayerLocation(this.getNaviLayerByValue('color', layer), ddMapPlan["color"]);
        validColorTypes.push("color");
        colorType = "color";
        this.mapInitialPosition = JSON.parse(JSON.stringify(ddMapPlan["color"]));
      }
      if (ddMapPlan["thermal"]) {
        this.setMapLayerLocation(this.getNaviLayerByValue('thermal', layer), ddMapPlan["thermal"]);
        validColorTypes.push("thermal");
        colorType = "thermal";
        if (!this.mapInitialPosition.bound_1_lng){
          this.mapInitialPosition = JSON.parse(JSON.stringify(ddMapPlan["thermal"]));
        }
      }
      store.updateMapViewValidColorTypes(validColorTypes);
      store.updateMapViewColorType(colorType);
    },
    setCoordinate(ddMapPlan){
      if((ddMapPlan["color_coordinate"])){
        this.orign_photos_color = ddMapPlan["color_coordinate"]["coordinate"];
        this.cal_photos_color = ddMapPlan["color_coordinate"]["coordinate_cal"];
        this.originLonLatColorLayer.setLayer(this.orign_photos_color, 2, 5);
        this.calcLonLatColorLayer.setLayer(this.cal_photos_color, 1, 5);
        this.displayOrigin(this.getNaviLayerByValue('coordinate_color', this.layers));
      }
      if((ddMapPlan["thermal_coordinate"])){
        this.orign_photos_thermal = ddMapPlan["thermal_coordinate"]["coordinate"];
        this.cal_photos_thermal = ddMapPlan["thermal_coordinate"]["coordinate_cal"];
        this.originLonLatThermalLayer.setLayer(this.orign_photos_thermal, 4, 6);
        this.calcLonLatThermalLayer.setLayer(this.cal_photos_thermal, 3, 6);
        this.displayOrigin(this.getNaviLayerByValue('coordinate_thermal', this.layers));
      }
    },

    changeFolder() {
      store.updateMapViewFolderId(this.folderId);
      store.updateMapViewValidColorTypes([]);
      store.updateMapViewColorType(null);
      router.push({name: "MapView", params: {folderId: this.folderId}});
      this.image360.resetLayers();
      this.resetLayers();
      this.originLonLatColorLayer.setLayer([], 2, 5);
      this.calcLonLatColorLayer.setLayer([], 1, 5);
      this.originLonLatThermalLayer.setLayer([], 4, 6);
      this.calcLonLatThermalLayer.setLayer([], 3, 6);
      this.showAnnotationAddDialog = false;
      this.showAnnotationEditDialog = false;
      this.showAnnotationCopyDialog = false;
      this.axios.get("/api/folder/layers-info/" + this.folderId).then((response) => {
        this.reportStatus = response.data.report_status;
        store.updateCurrentReportStatus(this.reportStatus);
        store.updateMapViewFolder(response.data.folder);
        this.importedFolder = response.data.csv_import_folder;
        this.annotationFilter.panel_error_types = store.getFilter(this.folderId).panel_error_types;
        this.annotationFilter.panel_error_reasons = store.getFilter(this.folderId).panel_error_reasons;
        // const airprobeLayer = this.getNaviLayerByValue('airprobe_annotation', this.layers);
        // airprobeLayer.disable = response.data.annotation.airprobe_abnormality.list.length === 0;
        // if (!airprobeLayer.disable){
        //   this.panel = [0, 1];
        // }
        // else {
        //   this.panel = [0];
        // }
        this.setDDMapPlanToMap(this.layers, response.data);
        this.setCoordinate(response.data);
        this.map
            .getView()
            .setCenter([
              (this.mapInitialPosition.bound_1_lng +
                  this.mapInitialPosition.bound_2_lng) /
              2,
              (this.mapInitialPosition.bound_1_lat +
                  this.mapInitialPosition.bound_2_lat) /
              2,
            ]);
        this.map
            .getView()
            .fit([
              this.mapInitialPosition.bound_1_lng,
              this.mapInitialPosition.bound_1_lat,
              this.mapInitialPosition.bound_2_lng,
              this.mapInitialPosition.bound_2_lat,
            ]);

        this.changeMapLayer(this.getLayerById('thermal', this.map), this.getNaviLayerByValue('thermal', this.layers));
        this.changeMapLayer(this.getLayerById('color', this.map), this.getNaviLayerByValue('color', this.layers));
        this.changeCoordinateLayer(this.getLayerById('coordinate_thermal', this.map));
        this.changeCoordinateLayer(this.getLayerById('coordinate_color', this.map));
        this.annotation.setSource(response.data.annotation);
        this.airprobeAnnotation.setSource(response.data.annotation);
      });

    },
    changeFolderId(folderId){
      this.folderId = folderId;
      this.changeFolder();
    },
    changeMapLayer(mapLayer, layer) {
      mapLayer.setSource(new XYZ({
        maxZoom: layer.maxZoom,
        minZoom: 17,
        attributions: "",
        url: layer.mapUrl,
        tileSize: [256, 256],
      }));
      mapLayer.setExtent([
        layer.bound1Lng,
        layer.bound1Lat,
        layer.bound2Lng,
        layer.bound2Lat,
      ]);
      mapLayer.setVisible(layer.visible);
      mapLayer.setOpacity(layer.transparency);
    },
    changeCoordinateLayer(layer) {
      layer.setVisible(false);
     
      if(layer.get('id') == 'coordinate_color'){
        layer.getLayers().getArray()[0].setSource(this.originLonLatColorLayer.layer.getSource());
        layer.getLayers().getArray()[1].setSource(this.calcLonLatColorLayer.layer.getSource());
      }
      if(layer.get('id') == 'coordinate_thermal'){
        layer.getLayers().getArray()[0].setSource(this.originLonLatThermalLayer.layer.getSource());
        layer.getLayers().getArray()[1].setSource(this.calcLonLatThermalLayer.layer.getSource());
      }
    },
    resetLayers() {
      this.layers = [
        {
          text: "アノテーション",
          value: "annotation",
          transparency: 100,
          visible: true,
        },
        {
          text: "AI MODEL A アノテーション",
          value: "airprobe_annotation",
          transparency: 100,
          visible: false,
          disable: false,
        },
        {
          origin_coordinate: {
            transparency: 100,
            visible: false,
            text: 'origin_thermal',
            value: 'origin_thermal',
          },
          cal_coordinate: {
            transparency: 100,
            visible: false,
            text: 'cal_thermal',
            value: 'cal_thermal',
          },
          text: "サーモ素材画像",
          value: "coordinate_thermal",
          transparency: 100,
          visible: false,
          mapUrl: "",
        },
        {
          text: "サーモオルソ画像",
          value: "thermal",
          transparency: 100,
          visible: false,
          mapUrl: "",
          bound1Lng: 0,
          bound1Lat: 0,
          bound2Lng: 0,
          bound2Lat: 0,
          lat_translate: 0,
          lng_translate: 0,
          maxZoom: null,
        },
        {
          origin_coordinate: {
            transparency: 100,
            visible: false,
            text: 'origin_color',
            value: 'origin_color',
          },
          cal_coordinate: {
            transparency: 100,
            visible: false,
            text: 'cal_color',
            value: 'cal_color',
          },
          text: "可視素材画像",
          value: "coordinate_color",
          transparency: 100,
          visible: false,
          mapUrl: "",
        },
        {
          text: "可視オルソ画像",
          value: "color",
          transparency: 100,
          visible: false,
          mapUrl: "",
          bound1Lng: 0,
          bound1Lat: 0,
          bound2Lng: 0,
          bound2Lat: 0,
          lat_translate: 0,
          lng_translate: 0,
          maxZoom: null,
        },
        {
          text: "ドローンパノラマ",
          value: "image360",
          transparency: 100,
          visible: false,
          mapUrl: "",
        },
        {
          text: "THETAパノラマ",
          value: "theta_image360",
          list: this.image360.image360Layer,
          transparency: 100,
          visible: this.image360.image360LayerVisible,
        },
        {
          text: "動画",
          value: "video",
          transparency: 100,
          visible: false,
          mapUrl: "",
        },
        {
          text: "図面",
          value: "diagram",
          transparency: 100,
          visible: false,
          mapUrl: "",
        },
        {
          openStreetMap: {
            transparency: 100,
            visible: true,
            text: "OpenStreetMap",
            value: 'OpenStreetMap',
          },
          satellite: {
            transparency: 100,
            visible: true,
            text: "Mapbox",
            value: 'Satellite',
          },
          visible: true,
          text: "ベースマップ",
          value: "basic",
        },
      ];
    },
    previousFolder() {
      const folders = this.folders;
      const currentPos = folders.findIndex((folder) => {
        return folder.value == this.folderId;
      });
      if (currentPos != folders.length - 1) {
        this.folderId = folders[currentPos + 1].value;
        this.changeFolder();
      }
    },
    nextFolder() {
      const folders = this.folders;
      const currentPos = folders.findIndex((folder) => {
        return folder.value == this.folderId;
      });
      if (currentPos > 0) {
        this.folderId = folders[currentPos - 1].value;
        this.changeFolder();
      }
    },
    initFolders() {
      this.axios
          .get(`/api/folder/get-folder-list/${this.folderId}`)
          .then((response) => {
            const folders = response.data;
            folders.forEach((folder) => {
              if (folder.property.shooting_height) {
                folder.property.shooting_height = folder.property.shooting_height.toString();
                folder.property.shooting_height = folder.property.shooting_height.split('M')[0];
              }
              this.folders.push({value: folder.id, text: folder});
              if (folder.id == this.folderId) {
                this.folderId = folder.id;
              }
            });
          });
    },
    afterAddAnnotation(info) {
      this.annotation.addFeature(info);
      this.annotationAddInfo = {};
      this.showSnackbarMessage("アノテーション追加は完了しました。");
      this.annotation.filter(store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
    },
    afterEditAnnotation(info) {
      this.annotation.editFeature(info);
      this.clickedAnnotation = info;
      this.showSnackbarMessage("アノテーション編集は完了しました。");
      this.annotation.filter(store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
    },
    afterDeleteAnnotation(info) {
      this.annotation.removeFeature(info);
      this.clickedAnnotation = null;
      this.showSnackbarMessage("アノテーション削除は完了しました。");
    },
    changeAnnotationMode(mode) {
      this.showAnnotationEditDialog = false;
      this.annotationAddInfo = {};
      this.annotation.mode = mode;
      if (this.annotation.mode !== "add") {
        this.annotation.removeTempFeature();
        this.showAnnotationAddDialog = false;
        //Show blue point on mousse if add mode
        this.map.removeInteraction(this.annotation.draw);
      } else {
        //Remove blue point on mouse if not add mode
        this.map.addInteraction(this.annotation.draw);
      }
    },
    afterMoveAnnotation(info) {
      if (this.annotation.mode === 'add') {
        this.annotationAddInfo.coordinates = info.coordinates;
      } else {
        this.annotationEditInfo = info;
        this.axios
            .put(`/api/annotation/${this.folderId}/coordinates`, info)
            .catch(() => {
              store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
      }
    },
    onCopyAnnotation() {
      this.showAnnotationCopyDialog = true;
    },
    afterCopyAnnotation(copyToFolderId) {
      this.folderId = copyToFolderId;
      this.changeFolder(0);
      this.showSnackbarMessage(`アノテーションコピーは完了しました。コピー先のデータを表示します。`);
    },
    showSnackbarMessage(message) {
      this.snackbarMessage = message;
      this.showSnackbar = true;
    },
    mapCompare() {
      this.compared = true;
    },
    hideBtnLeft() {
      switch (this.hideLeft) {
        case true: {
          if (this.compared){
            this.$el.querySelector('#navi-col').classList.add('hide-btn-left');
            if (this.$el.querySelector('#navi-col').classList.contains('unhide-btn-left')) {
              this.$el.querySelector('#navi-col').classList.remove('unhide-btn-left');
            }
          }
          else{
            this.$el.querySelector('#navi-col').classList.add('hide-btn-right');
            if (this.$el.querySelector('#navi-col').classList.contains('unhide-btn-right')) {
              this.$el.querySelector('#navi-col').classList.remove('unhide-btn-right');
            }
          }
          break;
        }
        case false: {
          if (this.compared){
            this.$el.querySelector('#navi-col').classList.add('unhide-btn-left');
            if (this.$el.querySelector('#navi-col').classList.contains('hide-btn-left')) {
              this.$el.querySelector('#navi-col').classList.remove('hide-btn-left');
            }
          }
          else {
            this.$el.querySelector('#navi-col').classList.add('unhide-btn-right');
            if (this.$el.querySelector('#navi-col').classList.contains('hide-btn-right')) {
              this.$el.querySelector('#navi-col').classList.remove('hide-btn-right');
            }
          }
          break;
        }
      }
      this.hideLeft = !this.hideLeft;
    },
    checkLayer(layer){
      if (['image360', 'video', 'diagram'].includes(layer.value)){
        return false;
      }
      return true;
    },
    turnOnOriginImageLayer(turnOn){
      this.layers.forEach((layer) => {
        if (!['annotation', 'thermal', 'color', 'diagram', 'basic'].includes(layer.value) && layer.mapUrl !== ''){
          this.getLayerById(layer.value, this.map).setVisible(turnOn);
        }
      });
    },

    translateLayer(layer){
      const latTranslate = this.getNaviLayerByValue(layer, this.layers).lat_translate;
      const lngTranslate = this.getNaviLayerByValue(layer, this.layers).lng_translate;

      if (lngTranslate != 0 || latTranslate != 0){
        this.getLayerById(layer, this.map).on('prerender', (event) => {
          const ctx = event.context;
          ctx.save();
          const a = this.map.getView().getResolution();
          ctx.translate(lngTranslate/a, (0-latTranslate)/a);
        });

        this.getLayerById(layer, this.map).on('postrender', (event) => {
            const ctx = event.context;
            ctx.restore();
        });
      }
    },
    displayImage(layer,evt, photos, imageType){
      const list_image = [];
      layer.getFeatures(evt.pixel)
      .then((features) => {
        const feature = features.length ? features[0] : undefined;
        if (feature) {
        var coord = feature.getGeometry().getCoordinates();
        coord = olProj.transform(coord, 'EPSG:3857', 'EPSG:4326');
        var name_array = feature.get('name').split("/");
        var currentIndex ;
        photos.forEach((element, key)=> {
          list_image.push({src: element.filename, rotate: element.rotate, crop: element.crop, annotation_mark: element.annotation_mark, filtered: element.filtered});
          // list_image.push(element.filename)
          if(element.filename == feature.get('name')){
            currentIndex = key;
          }
        });
        this.imageInfo = {
            long: coord[0],
            lat: coord[1],
            src: feature.get('name'),
            name: name_array[name_array.length - 1],
            list: list_image,
            currentIndex: currentIndex,
            type: imageType,
            rotate: feature.get('rotate'),
            crop: feature.get('crop'),
            annotation_mark: feature.get('annotation_mark'),
            filtered: feature.get('filtered'),
        }
        this.showImageDialog = true;
        }
      });
    },

    selectAllAnnotation(){
      this.annotation.allSelect = !this.annotation.allSelect;
      this.annotation.annotationLayer.setStyle(this.annotation.featureStyleFunction);

      if (this.annotation.allSelect){
        this.annotation.select = new Array();
        this.annotation.annotationLayer.getSource().forEachFeature((feature) => {
          this.annotation.select.push({id_: feature.id_, coordinates: feature.getGeometry().getCoordinates()});
        });
        this.annotation.selected = null;
        this.annotation.coordinatesDelta = [0, 0];
      }
      this.annotation.setAnnotationMoveMode(this.annotation.allSelect);
    },

    deleteAllAnnotation(){
      const confirmDialog = {
        title: "削除確認",
        content: '全部のアノテーションを削除します。よろしいですか。',
        onAgree: () => {
          this.axios
              .delete('/api/annotation/delete-all', {data : {'folderId':this.folderId}})
              .then((response) => {
                this.annotation.allSelect = !this.annotation.allSelect;
                this.annotation.annotationLayer.setStyle(this.annotation.featureStyleFunction);
                this.annotation.setSource(response.data);
                store.showSuccessDialog('一括削除しました。');
              })
              .catch(() => {
                this.annotation.annotationLayer.setStyle(this.annotation.featureStyleFunction);
                store.showErrorDialog("エラーが発生しました。再度試してください。");
              });
        },
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },

    setImage360Visible(visible){
      for (const layer of this.layers){
        if (layer.value === "theta_image360"){
          layer.visible = visible;
        }
      }
    },
    uploadCSV(e){
      if (!e.target.files || e.target.files.length === 0) return;
      for (const file of e.target.files) {
        const data = new FormData();
        data.append("file", file);
        this.axios
            .post('/api/annotation/airprobe/' + this.folderId, data)
            .then((response) => {
              this.airprobeAnnotation.setSource(response.data);
              store.showSuccessDialog('インポート完了しました。');
              this.getNaviLayerByValue('airprobe_annotation', this.layers).visible = true;
              this.getLayerById('airprobe_annotation', this.map).setVisible(true);
            })
            .catch(() => {
              store.showErrorDialog('アノテーションインポートにてエラーが発生されましたので、再度試してください。');
            })
            .finally(() => {
              e.target.value = null;
            });
      }
    },
    onUploadCSV(){
      this.$refs.csvUploader.click();
    },
    overwriteAnnotation(){
      const confirmDialog = {
        title: "上書確認",
        content: '全部の手動アノテーションが置き換えられます。よろしいですか。この行為は元に戻せないので、確認してください。',
        onAgree: () => {
          this.axios
              .post('/api/annotation/airprobe/overwrite/' + this.folderId)
              .then((response) => {
                this.annotation.setSource(response.data.annotation);
                // this.airprobeAnnotation.source.filter = response.data.annotation.filter;
                this.annotation.filter(store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
                for (const image in response.data.report.annotation_image.list) {
                  let photo = this.cal_photos_thermal.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                  if (photo){
                    photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                  }
                  photo = this.orign_photos_thermal.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                  if (photo){
                    photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                  }
                }
                this.originLonLatThermalLayer.updateAnnotationMark(response.data.report);
                this.calcLonLatThermalLayer.updateAnnotationMark(response.data.report);
                if (this.orign_photos_color.length > 0){
                  for (const image in response.data.report.annotation_image.list) {
                    let photo = this.cal_photos_color.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                    if (photo){
                      photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                    }
                    photo = this.orign_photos_color.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                    if (photo){
                      photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                    }
                  }
                  this.originLonLatColorLayer.updateAnnotationMark(response.data.report);
                  this.calcLonLatColorLayer.updateAnnotationMark(response.data.report);
                }
                store.showSuccessDialog('手動アノテーションが置き換えられました。');
              })
              .catch(() => {
                store.showErrorDialog('置き換える時にてエラーが発生されましたので、再度試してください。');
              });
        },
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    mergeAnnotation(){
      const confirmDialog = {
        title: "追加でコピー確認",
        content: '「AI MODEL A」の結果が手動アノテーションに追加でコピーされます。よろしいですか。',
        onAgree: () => {
          this.axios
              .post('/api/annotation/airprobe/merge/' + this.folderId)
              .then((response) => {
                this.annotation.setSource(response.data.annotation);
                // this.airprobeAnnotation.source.filter = response.data.filter;
                this.annotation.filter(store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
                for (const image in response.data.report.annotation_image.list) {
                  let photo = this.cal_photos_thermal.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                  if (photo){
                    photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                  }
                  photo = this.orign_photos_thermal.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                  if (photo){
                    photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                  }
                }
                this.originLonLatThermalLayer.updateAnnotationMark(response.data.report);
                this.calcLonLatThermalLayer.updateAnnotationMark(response.data.report);
                if (this.orign_photos_color.length > 0){
                  for (const image in response.data.report.annotation_image.list) {
                    let photo = this.cal_photos_color.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                    if (photo){
                      photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                    }
                    photo = this.orign_photos_color.find(photo => photo.filename.split(/[\\/]/).pop().split('.')[0] === image);
                    if (photo){
                      photo.annotation_mark = response.data.report.annotation_image.list[image]['abnormality_shape_list'];
                    }
                  }
                  this.originLonLatColorLayer.updateAnnotationMark(response.data.report);
                  this.calcLonLatColorLayer.updateAnnotationMark(response.data.report);
                }
                store.showSuccessDialog('「AI MODEL A」の結果が追加でコピーされました。');
              }).catch(() => {
                store.showErrorDialog('追加でコピーにてエラーが発生されましたので、再度試してください。');
              });
        },
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    getLayerById(id, fromLayer){
      const layers = fromLayer.getLayers().getArray();
      for (const layer of layers) {
        if (layer.get("id") == id){
          return layer;
        }
        else{
          if (layer instanceof LayerGroup){
            const a = this.getLayerById(id, layer);
            if (a) return a;
          }
        }
      }
      return null;
    },
    getNaviLayerByValue(value, layers){
      for (const layer of layers){
        if (layer.value == value){
          return layer;
        }
      }
      return null;
    },
    updateRotate(src, rotate, type, app='drone', listCropImage, listAnnotation){
      switch (type){
        case 'color': {
          let photo = this.cal_photos_color.find(photo => photo.filename === src);
          if (photo){
            photo.rotate = rotate;
            if (listCropImage.length > 0){
              if (Array.isArray(photo.crop)){
                photo.crop = {};
              }
              listCropImage.forEach(item => {
                photo.crop[item.custom_id].rect = {width: item.width, height: item.height, top: item.top, left: item.left};
              })
            }
            listAnnotation.forEach(item => {
              photo.annotation_mark[item.custom_id].width = item.width;
              photo.annotation_mark[item.custom_id].height = item.height;
              photo.annotation_mark[item.custom_id].top = item.top;
              photo.annotation_mark[item.custom_id].left = item.left;
            })
          }
          photo = this.orign_photos_color.find(photo => photo.filename === src);
          if (photo){
            photo.rotate = rotate;
            if (listCropImage.length > 0){
              if (Array.isArray(photo.crop)){
                photo.crop = {};
              }
              listCropImage.forEach(item => {
                photo.crop[item.custom_id].rect = {width: item.width, height: item.height, top: item.top, left: item.left};
              })
            }
            listAnnotation.forEach(item => {
              photo.annotation_mark[item.custom_id].width = item.width;
              photo.annotation_mark[item.custom_id].height = item.height;
              photo.annotation_mark[item.custom_id].top = item.top;
              photo.annotation_mark[item.custom_id].left = item.left;
            })
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.colorImages.find(photo => photo.src === src);
            if (photo){
              photo.rotate = rotate;
              if (listCropImage.length > 0){
                if (Array.isArray(photo.crop)){
                  photo.crop = {};
                }
                listCropImage.forEach(item => {
                  photo.crop[item.custom_id].rect = {width: item.width, height: item.height, top: item.top, left: item.left};
                })
              }
              listAnnotation.forEach(item => {
                photo.annotation_mark[item.custom_id].width = item.width;
                photo.annotation_mark[item.custom_id].height = item.height;
                photo.annotation_mark[item.custom_id].top = item.top;
                photo.annotation_mark[item.custom_id].left = item.left;
              })
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.updateRotate(src, rotate, type, listCropImage, listAnnotation);
          }
          this.originLonLatColorLayer.updateRotate(src, rotate, listCropImage, listAnnotation);
          this.calcLonLatColorLayer.updateRotate(src, rotate, listCropImage, listAnnotation);
          break;
        }
        case 'thermal': {
          let photo = this.cal_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            photo.rotate = rotate;
            if (listCropImage.length > 0){
              if (Array.isArray(photo.crop)){
                photo.crop = {};
              }
              listCropImage.forEach(item => {
                photo.crop[item.custom_id].rect = {width: item.width, height: item.height, top: item.top, left: item.left};
              })
            }
            listAnnotation.forEach(item => {
              photo.annotation_mark[item.custom_id].width = item.width;
              photo.annotation_mark[item.custom_id].height = item.height;
              photo.annotation_mark[item.custom_id].top = item.top;
              photo.annotation_mark[item.custom_id].left = item.left;
            })
          }
          photo = this.orign_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            photo.rotate = rotate;
            if (listCropImage.length > 0){
              if (Array.isArray(photo.crop)){
                photo.crop = {};
              }
              listCropImage.forEach(item => {
                photo.crop[item.custom_id].rect = {width: item.width, height: item.height, top: item.top, left: item.left};
              })
            }
            listAnnotation.forEach(item => {
              photo.annotation_mark[item.custom_id].width = item.width;
              photo.annotation_mark[item.custom_id].height = item.height;
              photo.annotation_mark[item.custom_id].top = item.top;
              photo.annotation_mark[item.custom_id].left = item.left;
            })
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.thermalImages.find(photo => photo.src === src);
            if (photo){
              photo.rotate = rotate;
              if (listCropImage.length > 0){
                if (Array.isArray(photo.crop)){
                  photo.crop = {};
                }
                listCropImage.forEach(item => {
                  photo.crop[item.custom_id].rect = {width: item.width, height: item.height, top: item.top, left: item.left};
                })
              }
              listAnnotation.forEach(item => {
                photo.annotation_mark[item.custom_id].width = item.width;
                photo.annotation_mark[item.custom_id].height = item.height;
                photo.annotation_mark[item.custom_id].top = item.top;
                photo.annotation_mark[item.custom_id].left = item.left;
              })
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.updateRotate(src, rotate, type, listCropImage, listAnnotation);
          }
          this.originLonLatThermalLayer.updateRotate(src, rotate, listCropImage, listAnnotation);
          this.calcLonLatThermalLayer.updateRotate(src, rotate, listCropImage, listAnnotation);
          break;
        }
      }
    },
    updateCropImage(src, cropImage, type, app='drone'){
      switch (type){
        case 'color': {
          let photo = this.cal_photos_color.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.crop)){
              photo.crop = {};
            }
            photo.crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
          }
          photo = this.orign_photos_color.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.crop)){
              photo.crop = {};
            }
            photo.crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.colorImages.find(photo => photo.src === src);
            if (photo){
              if (Array.isArray(photo.crop)){
                photo.crop = {};
              }
              photo.crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.updateCropImage(src, cropImage, type);
          }
          this.originLonLatColorLayer.updateCropImage(src, cropImage);
          this.calcLonLatColorLayer.updateCropImage(src, cropImage);
          break;
        }
        case 'thermal': {
          let photo = this.cal_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.crop)){
              photo.crop = {};
            }
            photo.crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
          }
          photo = this.orign_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.crop)){
              photo.crop = {};
            }
            photo.crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.thermalImages.find(photo => photo.src === src);
            if (photo){
              if (Array.isArray(photo.crop)){
                photo.crop = {};
              }
              photo.crop[cropImage.custom_id] = {rect: cropImage, errorNote: cropImage.errorNote, errorType: cropImage.errorType, errorReason: cropImage.errorReason};
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.updateCropImage(src, cropImage, type);
          }
          this.originLonLatThermalLayer.updateCropImage(src, cropImage);
          this.calcLonLatThermalLayer.updateCropImage(src, cropImage);
          break;
        }
      }
    },
    updateCropAbnormality(src, cropAbnormality, type, app='drone'){
      switch (type){
        case 'color': {
          let photo = this.cal_photos_color.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.annotation_mark)){
              photo.annotation_mark = {};
            }
            photo.annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
          }
          photo = this.orign_photos_color.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.annotation_mark)){
              photo.annotation_mark = {};
            }
            photo.annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.colorImages.find(photo => photo.src === src);
            if (photo){
              if (Array.isArray(photo.annotation_mark)){
                photo.annotation_mark = {};
              }
              photo.annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.updateCropAbnormality(src, cropAbnormality, type);
          }
          this.originLonLatColorLayer.updateCropAbnormality(src, cropAbnormality);
          this.calcLonLatColorLayer.updateCropAbnormality(src, cropAbnormality);
          break;
        }
        case 'thermal': {
          let photo = this.cal_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.annotation_mark)){
              photo.annotation_mark = {};
            }
            photo.annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
          }
          photo = this.orign_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            if (Array.isArray(photo.annotation_mark)){
              photo.annotation_mark = {};
            }
            photo.annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.thermalImages.find(photo => photo.src === src);
            if (photo){
              if (Array.isArray(photo.annotation_mark)){
                photo.annotation_mark = {};
              }
              photo.annotation_mark[cropAbnormality.custom_id] = cropAbnormality;
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.updateCropAbnormality(src, cropAbnormality, type);
          }
          this.originLonLatThermalLayer.updateCropAbnormality(src, cropAbnormality);
          this.calcLonLatThermalLayer.updateCropAbnormality(src, cropAbnormality);
          break;
        }
      }
    },
    deleteCropImage(src, cropImage, type, app='drone'){
      switch (type){
        case 'color': {
          let photo = this.cal_photos_color.find(photo => photo.filename === src);
          if (photo){
            delete photo.crop[cropImage.custom_id];
            if (!Object.keys(photo.crop).length){
              photo.crop = [];
            }
          }
          photo = this.orign_photos_color.find(photo => photo.filename === src);
          if (photo){
            delete photo.crop[cropImage.custom_id];
            if (!Object.keys(photo.crop).length){
              photo.crop = [];
            }
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.colorImages.find(photo => photo.src === src);
            if (photo){
              delete photo.crop[cropImage.custom_id];
              if (!Object.keys(photo.crop).length){
                photo.crop = [];
              }
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.deleteCropImage(src, cropImage, type);
          }
          this.originLonLatColorLayer.deleteCropImage(src, cropImage);
          this.calcLonLatColorLayer.deleteCropImage(src, cropImage);
          break;
        }
        case 'thermal': {
          let photo = this.cal_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            delete photo.crop[cropImage.custom_id];
            if (!Object.keys(photo.crop).length){
              photo.crop = [];
            }
          }
          photo = this.orign_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            delete photo.crop[cropImage.custom_id];
            if (!Object.keys(photo.crop).length){
              photo.crop = [];
            }
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.thermalImages.find(photo => photo.src === src);
            if (photo){
              delete photo.crop[cropImage.custom_id];
              if (!Object.keys(photo.crop).length){
                photo.crop = [];
              }
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.deleteCropImage(src, cropImage, type);
          }
          this.originLonLatThermalLayer.deleteCropImage(src, cropImage);
          this.calcLonLatThermalLayer.deleteCropImage(src, cropImage);
          break;
        }
      }
    },
    deleteCropAbnormality(src, cropAbnormality, type, app='drone'){
      switch (type){
        case 'color': {
          let photo = this.cal_photos_color.find(photo => photo.filename === src);
          if (photo){
            delete photo.annotation_mark[cropAbnormality.custom_id];
            if (!Object.keys(photo.annotation_mark).length){
              photo.annotation_mark = [];
            }
          }
          photo = this.orign_photos_color.find(photo => photo.filename === src);
          if (photo){
            delete photo.annotation_mark[cropAbnormality.custom_id];
            if (!Object.keys(photo.annotation_mark).length){
              photo.annotation_mark = [];
            }
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.colorImages.find(photo => photo.src === src);
            if (photo){
              delete photo.annotation_mark[cropAbnormality.custom_id];
              if (!Object.keys(photo.annotation_mark).length){
                photo.annotation_mark = [];
              }
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.deleteCropAbnormality(src, cropAbnormality, type);
          }
          this.originLonLatColorLayer.deleteCropAbnormality(src, cropAbnormality);
          this.calcLonLatColorLayer.deleteCropAbnormality(src, cropAbnormality);
          break;
        }
        case 'thermal': {
          let photo = this.cal_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            delete photo.annotation_mark[cropAbnormality.custom_id];
            if (!Object.keys(photo.annotation_mark).length){
              photo.annotation_mark = [];
            }
          }
          photo = this.orign_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            delete photo.annotation_mark[cropAbnormality.custom_id];
            if (!Object.keys(photo.annotation_mark).length){
              photo.annotation_mark = [];
            }
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.thermalImages.find(photo => photo.src === src);
            if (photo){
              delete photo.annotation_mark[cropAbnormality.custom_id];
              if (!Object.keys(photo.annotation_mark).length){
                photo.annotation_mark = [];
              }
            }
          }
          if (app === 'airprobe'){
            this.airprobeAnnotation.deleteCropAbnormality(src, cropAbnormality, type);
          }
          this.originLonLatThermalLayer.deleteCropAbnormality(src, cropAbnormality);
          this.calcLonLatThermalLayer.deleteCropAbnormality(src, cropAbnormality);
          break;
        }
      }
    },
    sendAirprobe(){
      const confirmDialog = {
        title: 'AI MODEL A異常検知を実行確認',
        content: "AI MODEL A異常検知を実行します。よろしいですか。",
        onAgree: () => {
          this.axios
              .get('/api/airprobe/check-required-data/' + this.folder.plant_id)
              .then((response) => {
                const property = response.data;
                if (!property.dc){
                  this.requiredDataDialog = true;
                }
                else {
                  this.sendAirprobeRequest();
                }
              });
        },
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    sendAirprobeRequest(){
      this.axios
          .post('/api/airprobe/send/', {folderId: this.folderId})
          .then(() => {
            store.showSuccessDialog('このフォルダがAI MODEL Aに送信されました。少々お待ちください。');
          })
          .catch(() => {
            store.showErrorDialog('AI MODEL Aに送信にて、エラーが発生されました。管理者にご連絡お願いいたします。');
          });
    },
    openTransferDialog(){
      this.airprobeAnnotationTransferDialog = true;
    },
    transferedAirprobeAnnotation(annotation){
      this.airprobeAnnotation.setSource(annotation);
      this.airprobeAnnotation.filter(store.getFilter(this.folderId).airprobe_error_types, store.getFilter(this.folderId).airprobe_severities, store.getFilter(this.folderId).panel_error_types, store.getFilter(this.folderId).panel_error_reasons);
      // this.calcLonLatThermalLayer.updateAnnotationMark(annotation.report);
    },
    openAnnotationFilterDialog(){
      this.annotationFilterDialog = true;
    },
    filter(panelErrorTypes, airprobeErrorTypes, panelErrorReasons, airprobeSeverities, applyForManual, applyForAP){
      if (applyForManual){
        this.annotation.filter(panelErrorTypes, panelErrorReasons);
      }
      if (applyForAP){
        this.airprobeAnnotation.filter(airprobeErrorTypes, airprobeSeverities, panelErrorTypes, panelErrorReasons);
      }
      this.annotationFilter.panel_error_types = panelErrorTypes;
      this.annotationFilter.panel_error_reasons = panelErrorReasons;
    },
    resetAirprobeAnnotation(annotation){
      this.airprobeAnnotation.setSource(annotation);
    },
    addCopyEventListener(){
      document.addEventListener('keydown', this.handleKeyPressed);
    },
    removeCopyEventListener(){
      document.removeEventListener('keydown', this.handleKeyPressed);
    },
    showAirprobeAnnotation(src, filtered, type){
      switch (type){
        case 'color': {
          let photo = this.cal_photos_color.find(photo => photo.filename === src);
          if (photo){
            photo.filtered = filtered;
          }
          photo = this.orign_photos_color.find(photo => photo.filename === src);
          if (photo){
            photo.filtered = filtered;
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.colorImages.find(photo => photo.src === src);
            if (photo){
              photo.filtered = filtered;
            }
          }
          this.originLonLatColorLayer.updateFilter(src, filtered);
          this.calcLonLatColorLayer.updateFilter(src, filtered);
          break;
        }
        case 'thermal': {
          let photo = this.cal_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            photo.filtered = filtered;
          }
          photo = this.orign_photos_thermal.find(photo => photo.filename === src);
          if (photo){
            photo.filtered = filtered;
          }
          if (JSON.stringify(this.annotationEditInfo) !== JSON.stringify({})){
            photo = this.annotationEditInfo.thermalImages.find(photo => photo.src === src);
            if (photo){
              photo.filtered = filtered;
            }
          }
          this.originLonLatThermalLayer.updateFilter(src, filtered);
          this.calcLonLatThermalLayer.updateFilter(src, filtered);
          break;
        }
      }
    }

  },

  computed: {
    editable() {
      return this.reportStatus === 'NEW' || this.reportStatus === 'BRANCH_REQUEST_REJECTED' || this.reportStatus === 'AREA_REQUEST_REJECTED' || this.reportStatus === 'SUBMIT_REJECTED';
    }
  },

  created() {
    this.initFolders();
    this.addCopyEventListener();
    // document.addEventListener('keydown', this.handleKeyPressed);
    store.updateMapViewValidColorTypes([]);
    store.updateMapViewColorType(null);
    store.setChangeMapviewColorType((colorType) => {
      store.updateMapViewColorType(colorType);
      const anotherColorType = colorType == 'thermal' ? 'color' : 'thermal';
      this.changeColorTypeVisible(colorType, true);
      this.changeColorTypeVisible(anotherColorType, false);
    });
    this.$root.$on('reportStatusChanged', (status) => {
      this.reportStatus = status;
    });
  },

  mounted() {
    this.initMap();
  },

  beforeDestroy() {
    // document.removeEventListener('keydown', this.handleKeyPressed);
    this.removeCopyEventListener();
  }
};
</script>

<style>
.full-size {
  width: 100%;
  height: 100%;
}

#map2d {
  width: auto;
  height: 100%;
}

#navi {
  border-left: 1px solid #ccc;
  width: auto;
  height: 100%;
}

#navi .v-expansion-panel-header {
  font-weight: 600;
}

#navi .v-expansion-panel-content__wrap{
  padding-left: 12px;
  padding-right: 12px;
}

#navi .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

#navi-col{
  position: absolute;
  background-color: white;
}

#navi .theme--light.v-expansion-panels .v-expansion-panel--disabled {
  background-color: #ccc;
}

#navi .v-expansion-panels {
  width: 290px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}

#float-panel {
  position: absolute;
  top: 10px;
  left: 22px;
  z-index: 1;
  border-radius: 4px;
  color: white;
}

.float-panel-right {
  right: 20px;
}

#folder-select-section {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  width: auto;
  padding-bottom: 0;
  padding-top: 0;
}

#map-compare {
  width: auto;
  z-index: 90;
  margin-left: 10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.8);
  padding-left: 5px;
  padding-right: 5px;
  height: 70px;
}

#map-compare:hover {
  cursor: pointer;
}

#annotation-filter {
  width: auto;
  z-index: 90;
  margin-left: 10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.8);
  height: 70px;
}

#annotation-filter:hover{
  cursor: pointer;
}

.btn-right {
  position: absolute;
  right: 290px;
  top: 38%;
}

.btn-origin-left {
  position: absolute;
  right: 290px;
  top: 38%;
}

.v-text-field {
  padding-top: 0;
}

.ol-zoom {
  top: auto;
  bottom: 0.5em;
}

.annotationInfoDialog.v-dialog {
  position: absolute;
  top: 140px;
  left: 10px;
  margin: 0px;
}

@keyframes hide-btn-right {
  from {
    right: 0;
  }
  to {
    right: -290px
  }
}

.hide-btn-right {
  right: -290px;
  animation: hide-btn-right;
  animation-duration: 0.5s;
  animation-delay: 0s;
}

@keyframes unhide-btn-right {
  from {
    right: -290px;
  }
  to {
    right: 0;
  }
}

.unhide-btn-right {
  right: 0;
  animation: unhide-btn-right;
  animation-duration: 0.5s;
  animation-delay: 0s;
}

.filter-btn{
  position: absolute;
  left: -100px;
  top: 20px;
}
.v-expansion-panel-header:before {
  background-color: #FFF !important;
}
</style>
